.footerContainer {
  position: sticky;
  bottom: 0;
  z-index: 5;
  background: rgba(251, 252, 255, 0.96);
  border-top: 1px solid var(--color-border);
  backdrop-filter: blur(12px);
}

.footerContent {
  max-width: var(--page-max-width);
  min-height: 4rem;
  margin: 0 auto;
  padding-inline: var(--header-footer-padding-x);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.backButton {
  composes: footerButton from "../../styles/components.module.css";
  background: var(--color-surface);
  color: var(--color-primary);
}

.finishButton {
  composes: footerButton from "../../styles/components.module.css";
  min-width: 15rem;
  border-color: transparent;
  background: var(--color-primary);
  color: var(--color-primary-text);
}
